import { useEffect, useState } from "react";
import axios from "axios";
// import { useSelector } from "react-redux";
import axiosClient from "../../utils/axiosClient";
// import toast from "react-hot-toast";

const useMultipleFileUploadAws = () => {
  // const userState = useSelector((state) => state.partner);
  const [uploadErrors, setUploadErrors] = useState({});
  const [uploadProgresses, setUploadProgresses] = useState({});
  const [estimatedTimes, setEstimatedTimes] = useState({});
  const [cancelTokenSources, setCancelTokenSources] = useState({});
  const [mediaUrls, setMediaUrls] = useState({});
  // const [error, setError] = useState(null);

  useEffect(() => {
    return () => {
      cancelAllUploads();
    };
  }, []);

  const uploadFileToS3 = async (file, axiosInstance = axiosClient) => {
    console.log('File:___', file);
    
    const key = `${Date.now()}${file.name}`;
    const contentType = file.type;
    const source = axios.CancelToken.source();    
    setUploadErrors((prevErrors) => ({ ...prevErrors, [file.name]: null }));
    setUploadProgresses((prevProgress) => ({ ...prevProgress, [file.name]: 0 }));
    setEstimatedTimes((prevTimes) => ({ ...prevTimes, [file.name]: "Calculating..." }));
    setCancelTokenSources((prevSources) => ({ ...prevSources, [file.name]: source }));

    try {
      const response = await axiosInstance.post(
        `/upload/uploadImage`,
        { filename: key, contenttype: contentType },
      );      
      const { uploadUrl } = response;      
      const config = {
        onUploadProgress: (progressEvent) => {
          const { progress, estimated } = progressEvent;
          const progressPercentage = (progress * 100).toFixed(2);
          const formattedTime = formatTime(estimated);

          setUploadProgresses((prevProgress) => ({
            ...prevProgress,
            [file.name]: progressPercentage,
          }));

          setEstimatedTimes((prevTimes) => ({
            ...prevTimes,
            [file.name]: formattedTime,
          }));
        },
        cancelToken: source.token,
      };

      await axios.put(uploadUrl, file, config);

      setUploadProgresses((prevProgress) => ({
        ...prevProgress,
        [file.name]: 100,
      }));

      setEstimatedTimes((prevTimes) => ({
        ...prevTimes,
        [file.name]: '0 seconds',
      }));

      const mediaUrlResponse = await axiosInstance.get(
        `/upload/getImageURL/${key}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      const mediaUrl = mediaUrlResponse.downloadUrl;
      const parsedUrl = new URL(mediaUrl);
      const baseUrl = `${parsedUrl.protocol}//${parsedUrl.host}${parsedUrl.pathname}`;

      setMediaUrls((prevUrls) => ({
        ...prevUrls,
        [file.name]: baseUrl,
      }));

      // toast.success(`Image ${file.name} Uploaded Successfully`);
    } catch (error) {
      if (axios.isCancel(error)) {
        // toast.error("Image upload canceled!");
      } else {
        setUploadErrors((prevErrors) => ({ ...prevErrors, [file.name]: error }));
        // toast.error(`Image upload failed for ${file.name}. Please try again.`);
        console.error(`Error uploading file ${file.name}:`, error);
      }
    }
  };

  const formatTime = (seconds) => {
    if (seconds < 60) return `${Math.ceil(seconds)} seconds`;
    else if (seconds < 3600) return `${Math.ceil(seconds / 60)} minutes`;
    else return `${Math.ceil(seconds / 3600)} hours`;
  };

  const cancelAllUploads = () => {
    Object.values(cancelTokenSources).forEach((source) => {
      source.cancel("Upload canceled by user");
    });
  };

  const cancelUpload = (fileName) => {
    if (cancelTokenSources[fileName]) {
      cancelTokenSources[fileName].cancel(`Upload ${fileName} canceled by user`);
    }
  };

  const resetFileUploadState = (fileName) => {
    setMediaUrls((prevMediaUrls) => {
      const { [fileName]: _, ...restMediaUrls } = prevMediaUrls;
      return restMediaUrls;
    });
    setUploadProgresses((prevUploadProgresses) => {
      const { [fileName]: _, ...restUploadProgresses } = prevUploadProgresses;
      return restUploadProgresses;
    });
    setUploadErrors((prevErrors) => {
      const { [fileName]: _, ...restErrors } = prevErrors;
      return restErrors;
    });
    setCancelTokenSources((prevCancelTokenSources) => {
      const { [fileName]: _, ...restCancelTokenSources } = prevCancelTokenSources;
      return restCancelTokenSources;
    });
  };


  return { uploadErrors, uploadFileToS3, cancelUpload, resetFileUploadState, mediaUrls, uploadProgresses, estimatedTimes };
};

export default useMultipleFileUploadAws;
